import React from "react";
import ReactLoading from "react-loading";
import { TimeFive } from "@styled-icons/boxicons-regular";
import { Forbid } from "@styled-icons/remix-fill";
import { EntryIndicator, SentPostIndicator } from "./styles";

import { theme } from "theme";
import Icon from "components/common/Icon";

const statusIcons = {
  SCHEDULED: <TimeFive size={14} />,
  TASK_SCHEDULE: <TimeFive size={14} />,
  TASK_SCHEDULE_PREVIEW: <TimeFive size={14} />,
  TRANSCODING: <TimeFive size={14} />,
  SENT: <SentPostIndicator size={14} />,
  STUCK: <Icon icon="icon-error" size={"sm"} />,
  TRANSCODING_ERROR: <Forbid size={14} />,
  PUBLISH_ERROR: <Forbid size={14} />,
  // Pre-rename values; drop once the backend status migration has run everywhere.
  PROCESSING: <TimeFive size={14} />,
  PROCESSING_ERROR: <Forbid size={14} />,
  DRAFT: <Icon icon="icon-draft" variant={"progress"} size={"sm"} />,
  REGENERATING: (
    <ReactLoading type="spin" color={theme.colors.blue} width={14} height={14} />
  )
};

type StatusIconKeys = keyof typeof statusIcons;

const errorTitles: Record<string, string> = {
  MEDIA_UNAVAILABLE:
    "This image or video is no longer available. Open the post and attach it again."
};

function EntryStatus({
  status,
  lastErrorType
}: {
  status: StatusIconKeys | "NEW";
  lastErrorType?: string | null;
}) {
  if (!status || status === "NEW") return null;

  return (
    <EntryIndicator
      $status={status}
      title={lastErrorType ? errorTitles[lastErrorType] : undefined}
    >
      {statusIcons[status]}
    </EntryIndicator>
  );
}

export default EntryStatus;
